import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ExternalChannelInfoPopup } from './ExternalChannelInfoPopup';

export const EXTERNAL_CHANNEL_INFO_POPUP = Symbol('EXTERNAL_CHANNEL_INFO_POPUP');

export const useExternalChannelInfoPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(EXTERNAL_CHANNEL_INFO_POPUP, ExternalChannelInfoPopup);
  });

  return useCallback(
    ({ name, items }) => {
      return new Promise((resolve) => {
        popups.openPopup(EXTERNAL_CHANNEL_INFO_POPUP, {
          name,
          items,
          onClose: (result) => {
            popups.closePopup(EXTERNAL_CHANNEL_INFO_POPUP);
            resolve(result);
          },
        });
      });
    },
    [popups]
  );
};
